
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"id\":1,\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true,\"autoprefixer\":true,\"importLoaders\":1}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-68ddb7e8\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":true}!./sky-swiper.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&cacheDirectory=true&sourceMap=true!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./sky-swiper.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-68ddb7e8\"}!./sky-swiper.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/sky-swiper/sky-swiper.vue
// module id = 337
// module chunks = 1